import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'ati-ui-react/components/AtiSelect';
import SearchParameter from '../SearchParameter';

const TypeOfAdvert = observer(() => {
  const {
    findTrucksStore: { pagination, initialSearchState, getTrucksResults },
    geoSearchStore: { resetSuggestions },
  } = useStores();
  const history = useHistory();
  const location = useLocation();

  const options = [
    {
      label: 'Продажа',
      value: '/trucks',
    },
    {
      label: 'Аренда',
      value: '/trucks/rent',
    },
    {
      label: 'Заявки на покупку',
      value: '/trucks/proposals-purchase',
    },
    {
      label: 'Заявки на аренду',
      value: '/trucks/proposals-rent',
    },
  ];

  const handleSelect = ({ value }: { value: string }) => {
    history.push(value);
    pagination.resetPage();
    initialSearchState();
    resetSuggestions();
    getTrucksResults();
  };

  return (
    <SearchParameter caption="Тип объявления" typeOfTransport strong>
      <Select
        placeholder="Выберите тип объявления"
        value={location.pathname}
        options={options}
        onChange={handleSelect}
        clearable={false}
        searchable={false}
      />
    </SearchParameter>
  );
});

export default TypeOfAdvert;
